module.exports = __webpack_public_path__ + "fromGroomToParents-jp-w.90ff98a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-jp-w.jpg
// module id = JGxo
// module chunks = 0